<template>
  <div>
    <img src="@/assets/img/join/banner.png" style="width: 100%;" alt="" />
    <div class="module">
      <div class="title">
        <div class="title_cn">厂家入驻</div>
      </div>
      <div class="form" style="margin-top: 0.5rem">
        <div class="l-input">
          <label for="user">厂家名称</label>
          <input
            placeholder="请输入厂家名称"
            type="text"
            name="area"
            id="user"
            v-model="form.settled_name"
          />
        </div>
        <div class="l-input">
          <label for="user">联系人</label>
          <input
            placeholder="请输入联系人姓名"
            type="text"
            name="area"
            id="user"
            v-model="form.link_name"
          />
        </div>
        <div class="l-input">
          <label for="phone">联系电话</label>
          <input v-model="form.link_telephone"  placeholder="请输入电话" type="text" name="area" id="phone" />
        </div>
        <div class="l-input">
          <label for="phone">职位</label>
          <input v-model="form.rank_name" placeholder="请输入职位" type="text" name="area" id="phone" />
        </div>
        <div class="l-input">
            <label for="phone">品类</label>
            <input v-model="form.cate_name" placeholder="请输入品类" type="text" name="area" id="phone" />
        </div>
        <div class="submit" @click="submit">确定加入</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "",
  data () {
      return {
          form: {
                settled_name: '',
                link_name: '',
                link_telephone: '',
                rank_name: '',
                cate_name: ''
          }
      }
  },
  methods : {
    submit(){
        let self = this, valid = true, phonevalid = true;

        Object.keys(this.form).forEach(res => {
            if (!self.form[res]){
                valid = false;
            }
            if (res == 'link_telephone' && self.form[res].length != 11){
              phonevalid = false;
            }
        })

        if (!phonevalid){
          alert('请输入正确的手机号')
          return;
        }
        if (!valid){
            alert('请完善入驻信息');
            return;
        }
        axios.post('/api/settled', this.form).then(res =>{
            if (res.data.code == 200){
                alert('提交成功');
            }
        })

    }
  }
};
</script>

<style lang="scss" scoped>
.module {
  padding: 1.3rem 0;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 0.22rem;
}

.l-input {
  margin: 0.08rem 0;
  position: relative;
}

.select-button {
  width: 1.2rem;
  height: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
  background: rgba(55, 148, 252, 1);
  border-radius: 0.24rem;
  position: absolute;
  color: #ffffff;
  right: -1px;
  font-size: 0.2rem;
  top: 0.12rem;
  cursor: pointer;
}

.submit {
  width: 1.68rem;
  height: 0.48rem;
  line-height: 0.48rem;
  text-align: center;
  background: rgba(55, 148, 252, 1);
  border-radius: 0.24rem;
  color: #ffffff;
  font-size: 0.2rem;
  cursor: pointer;
  margin-top: 0.4rem;
}

label {
  font-size: 0.2rem;
  color: #333333;
  width: 1rem;
  display: inline-block;
}
input {
  font-size: 0.2rem;
  color: #333333;
  height: 0.48rem;
  padding: 0 0.3rem;
  -webkit-border-radius: 0.24rem;
  -moz-border-radius: 0.24rem;
  border-radius: 0.24rem;
  outline: none;
  border: 1px solid #979797;
  width: 3.4rem;
}

</style>
